import script from "./HorizontalNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./HorizontalNavbar.vue?vue&type=script&setup=true&lang=js"

import "./HorizontalNavbar.vue?vue&type=style&index=0&id=85c6898a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85c6898a"]])

export default __exports__